const API_URL = '/wp/index.php?rest_route=/wc/store/v1';

let wcNonce = null;

const getHeaders = () => {
  const headers = { 'Content-Type': 'application/json' };
  const cartToken = localStorage.getItem('wc_cart_token');
  if (cartToken) headers['Cart-Token'] = cartToken;
  if (wcNonce) headers['Nonce'] = wcNonce;
  return headers;
};

const handleResponse = async (response) => {
  if (response.headers.has('Cart-Token')) {
    localStorage.setItem('wc_cart_token', response.headers.get('Cart-Token'));
  }
  if (response.headers.has('Nonce')) {
    wcNonce = response.headers.get('Nonce');
  }
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'Erro na requisição WooCommerce');
  }
  return response.json();
};

const mapProduct = (wp) => ({
  id: wp.id,
  slug: wp.slug,
  name: wp.name,
  image: wp.images?.[0]?.src || '',
  gallery: wp.images?.map(img => img.src) || [],
  price: parseFloat(wp.prices?.price) / 100 || 0,
  oldPrice: wp.prices?.regular_price && wp.prices.regular_price !== wp.prices.price ? parseFloat(wp.prices.regular_price) / 100 : undefined,
  category: wp.categories?.[0]?.name || 'Geral',
  categorySlug: wp.categories?.[0]?.slug || 'geral',
  brand: 'Sulbel',
  inStock: wp.is_in_stock,
  rating: wp.average_rating ? parseFloat(wp.average_rating) : 5,
  reviews: wp.review_count || 0,
  featured: wp.is_featured || false,
  bestSeller: wp.is_featured || false,
  sku: wp.sku,
  short_description: wp.short_description || ''
});

export const getProducts = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const url = `${API_URL}/products${query ? '&' + query : ''}`;
  const response = await fetch(url, { headers: getHeaders() });
  const data = await handleResponse(response);
  return data.map(mapProduct);
};

export const getProduct = async (slug) => {
  const response = await fetch(`${API_URL}/products&slug=${encodeURIComponent(slug)}`, { headers: getHeaders() });
  const data = await handleResponse(response);
  if (!data || data.length === 0) throw new Error('Produto não encontrado');
  return mapProduct(data[0]);
};

export const initCartSession = async () => {
  // Faz um GET no carrinho para obter o Token e o Nonce inicial
  const response = await fetch(`${API_URL}/cart`, { headers: getHeaders() });
  await handleResponse(response);
};

export const checkoutWithWooCommerce = async (items) => {
  localStorage.removeItem('wc_cart_token'); // Start a fresh remote cart
  wcNonce = null;
  
  await initCartSession();
  
  for (const item of items) {
    const response = await fetch(`${API_URL}/cart/items`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({
        id: item.product.id,
        quantity: item.qty
      })
    });
    await handleResponse(response);
  }
  
  return true;
};
